import {
    getAllOTAAPIHistoryAPI,
} from './apis'
import *  as commonActions from "../../common/actions"
import { errorMessage } from '../../../utils'

export const GET_ALL_OTA_HISTORY_REQUEST = 'GET_ALL_OTA_HISTORY_REQUEST';
export const GET_ALL_OTA_HISTORY_SUCCESS = 'GET_ALL_OTA_HISTORY_SUCCESS';
export const GET_ALL_OTA_HISTORY_FAILED = 'GET_ALL_OTA_HISTORY_FAILED';

export const getAllOTAHistory = (filters) => dispatch =>
    new Promise((resolve, reject) => {
        dispatch({
            type: GET_ALL_OTA_HISTORY_REQUEST
        })
        getAllOTAAPIHistoryAPI(filters).then(res => {
            const { info = {} } = res
            dispatch({
                type: GET_ALL_OTA_HISTORY_SUCCESS,
                payload: info
            })
            return resolve(res)
        }).catch(err => {
            dispatch({
                type: GET_ALL_OTA_HISTORY_FAILED
            })
            dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
            return reject(err)
        })
    })

export const CLEAR_ALL_OTA_HISTORY_DATA = 'CLEAR_ALL_OTA_HISTORY_DATA';

export const clearStoreForOTAHistory = () => {
    return (dispatch) => {
        dispatch({
            type: CLEAR_ALL_OTA_HISTORY_DATA
        })
    }
}